import { Global } from "@emotion/react";
import { ReactNode } from "react";
import React, { useEffect, useState } from "react";
import { globalStyles } from "../utils/global-styles";
import Header from "./Header";
import Footer from "./Footer";
import Announcement from "./Announcement";
// import { LiveChatLoaderProvider, Drift } from "react-live-chat-loader";

type LayoutProps = {
  blog? : boolean,
  children: ReactNode,
  simpleHeader? : boolean,
  disableDrift? : boolean,
  hideBanner?: boolean
}

declare global {
  interface Window {
    OnetrustActiveGroups? : string
  }
}

const Layout : React.FC<LayoutProps> = ({blog, children, simpleHeader, disableDrift, hideBanner, ...props}) => {
  const currentAnnouncementId = "announceGreenRegion0228";
  let hideCurrentAnnouncement = false;
  const [isAnnouncementHidden, setisAnnouncementHidden] = useState(hideCurrentAnnouncement);

  useEffect(() => {
    /* Check if the announcement has already been hidden */
    if (sessionStorage.getItem('upsun_hide_announce') == currentAnnouncementId || hideBanner) {
      setisAnnouncementHidden(true);
    }

    /* Begin marketing referral tracking */
    /* Array of parameters that we'll need to reference throughout */
    const relevantParams = [
      "utm_medium",
      "utm_campaign",
      "utm_source",
      "utm_content",
      "utm_term",
      "trial_type",
      "gclid"
    ];

    /* Grabs params from the URL and updates their values in localStorage if applicable */
    const setLocalFromURL = () => {
      const urlQueries = window.location.search;

      if (!urlQueries) {
        return;
      }

      const urlParams = new URLSearchParams(urlQueries);

      relevantParams.forEach(param => {
        const paramValue = urlParams.get(param);

        if (!paramValue) {
          return;
        }

        localStorage.setItem("rt_" + param, paramValue);
      });
    };

    /* Construct the string of params and values */
    const generateParamString = () => {
      let paramString = "";

      relevantParams.forEach(param => {
        let stored = localStorage.getItem("rt_" + param);
        
        if (!stored) {
          return;
        }

        paramString = paramString + "&_" + param + "=" + stored;
      });

      return paramString;
    };
    
    /* Update attributes in the DOM accordingly */
    // TODO: Add types later
    const updateLinkVals = (elArray : any, attr : any, newParamString : any) => {
      elArray.forEach((el : any) => {
        let origHref = el.getAttribute(attr);
        origHref += origHref.includes("?")
          ? newParamString
          : "?" + newParamString.substring(1);
        el.setAttribute(attr, origHref);
      });
    };

    /* Init */
    // Check consent from onetrust, only if consent exists, store URL params in localStorage.
    let consentGroups = "";
    let consentGroupsArray : string[] = []

    if(window) {
      consentGroups = window.OnetrustActiveGroups || "";
      consentGroupsArray = consentGroups.split(",");
    }

    if(consentGroupsArray.includes("C0002")) {
      setLocalFromURL();
    }

    let redirectParams = generateParamString();
   
    if (document.getElementById("mktg-redirect")) {
      if (redirectParams.indexOf("trial_type") < 0) {
        // Set trial_type general if there isn't already a trial_type
        redirectParams = redirectParams + "&_trial_type=general";
      }
      
      window.location.href = 
        "https://auth.upsun.com/register?" + redirectParams.substring(1);
    }
    
    /* Assuming we didn't redirect, tack the params onto these various other links */
    const linksToRefer = document.querySelectorAll(
      'a[href*="auth.upsun.com"],a[href*="console.upsun.com"]'
    );

    if (linksToRefer) {
      updateLinkVals(linksToRefer, "href", redirectParams);
    }
  }, [typeof window !== `undefined`]);
  /* End mktg referral tracking */
  
  return(
    <>
      {/* <LiveChatLoaderProvider providerKey="7prg3wvt49yk" provider="drift" idlePeriod={1}> */}
        <Global styles={globalStyles} />
        {!isAnnouncementHidden &&
          <Announcement 
            text="New greener region discount. Save 3% on Upsun resource usage." 
            linkText="Learn how." 
            href="/blog/greener-region-discount/"
            /* Icons will be a nice component when we get the design system up.
            Just... avert your eyes for now, or something. */
            icon={
              <svg width="41" height="42" viewBox="0 0 41 42" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M7.34584 34.1529C7.68751 34.4945 8.02918 34.6654 8.54168 34.6654C9.05418 34.6654 9.39584 34.4945 9.73751 34.1529L12.8125 31.0779C14.35 31.7612 16.5708 32.4445 18.9625 32.4445C21.6958 32.4445 24.6 31.5904 27.3333 29.0279C33.1417 23.2195 34.1667 9.7237 34.1667 9.2112C34.1667 8.6987 33.9958 8.1862 33.6542 7.84453C33.3125 7.50286 32.8 7.33203 32.2875 7.33203C31.775 7.33203 17.9375 8.6987 12.4708 14.1654C9.05418 17.582 8.54168 21.682 9.22501 25.0987L19.475 19.4612L7.17501 31.7612C6.66251 32.4445 6.66251 33.4695 7.34584 34.1529Z" fill="#D5F800"/>
              </svg>
            }
            id={currentAnnouncementId}
            closed={isAnnouncementHidden}
          />
        }
        <Header blog={blog as boolean} simpleHeader={simpleHeader} />
        <main>
          {children}
        </main>
        <Footer />
        {/* {!disableDrift && <Drift />} */}
      {/* </LiveChatLoaderProvider> */}
    </>
  );
}

export default Layout;
